import React, { useState } from "react";
import NotificationItem from "./NotificationItem";

interface NotificationListProps {
  isLoading: boolean;
  notificationsData: any[];
  handleDismiss: (notificationId: string) => void;
  handleMarkAsRead: (notificationId: string) => void;
  handleOpen?: (notification: any) => void;
}

const NotificationList: React.FC<NotificationListProps> = ({
  notificationsData,
  isLoading,
  handleDismiss,
  handleMarkAsRead,
  handleOpen,
}) => {
  const [filter, setFilter] = useState<"all" | "unread">("all");

  const mapped = (notificationsData || []).map((n) => ({
    id: n.id,
    message: n.message || "No message",
    timestamp: n.timestamp || new Date().toLocaleString(),
    sender: n.sender || "System",
    avatarText: n.avatarText || "S",
    isNew: n.isNew,
    href: n.href,
  }));

  const unreadCount = mapped.filter((n) => n.isNew).length;
  const displayed = filter === "unread" ? mapped.filter((n) => n.isNew) : mapped;

  return (
    <div className="-mx-6 -mt-6">
      {/* Summary bar */}
      <div className="flex items-center justify-between px-6 py-3 border-b border-gray-100 bg-gray-50/60">
        <p className="text-xs text-gray-400">
          {isLoading
            ? "Loading…"
            : `${mapped.length} notification${mapped.length !== 1 ? "s" : ""}`}
        </p>
        {unreadCount > 0 && (
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-[#143887] text-white text-[10px] rounded-full font-semibold tracking-wide">
            <span className="w-1.5 h-1.5 rounded-full bg-white/70 inline-block" />
            {unreadCount} unread
          </span>
        )}
      </div>

      {/* Filter tabs */}
      <div className="flex gap-1.5 px-5 py-3 border-b border-gray-100">
        {(["all", "unread"] as const).map((tab) => (
          <button
            key={tab}
            onClick={() => setFilter(tab)}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all ${
              filter === tab
                ? "bg-[#143887] text-white shadow-sm"
                : "text-gray-500 bg-gray-100 hover:bg-gray-200"
            }`}
          >
            {tab === "all"
              ? `All${mapped.length > 0 ? ` (${mapped.length})` : ""}`
              : `Unread${unreadCount > 0 ? ` (${unreadCount})` : ""}`}
          </button>
        ))}
      </div>

      <NotificationItem
        filteredNotifications={displayed}
        isLoading={isLoading}
        handleDismiss={handleDismiss}
        handleMarkAsRead={handleMarkAsRead}
        handleOpen={handleOpen}
      />
    </div>
  );
};

export default NotificationList;
